import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import { useFormikWrapper } from "../../../components/formik_wrapper";
import * as Yup from "yup";

import moment from "moment";
import Datepicker from "react-tailwindcss-datepicker";

import * as actions from "../../../actions";

import {
  CompanyStatus,
  currencies,
  timezones,
} from "../../../util/master-data";

import { countries } from "../../../util/master-data";
import { DataTable } from "../../../components/data-table";
import {
  FileChooser,
  SearchDropdown,
  TextBox,
} from "../../../components/inputs";
import { Popup } from "../../../components/pop-up";
import { ToggleCustomerStatus } from "../components/customer_toggle_action";
import { FlatButton, IconButton } from "../../../components/buttons";
import { ACL } from "../../../components/acl";
import { ADMIN, SUPERADMIN, FINANCEADMIN } from "../../../constants/roles";
import { AddAccountManager } from "../components/add_account_manager";
import { Chip } from "../../../components/chip";
import { useNavigate } from "react-router-dom";

const validationSchema = Yup.object({
  company_name: Yup.string().required("Company is required"),
  company_phone: Yup.string(),
  // .matches(
  //   /^(?:\+\d{1,3}\s?)?(?:\(\d{1,4}\)|\d{1,4})[-.\s]?\d{1,12}[-.\s]?\d{1,12}$/,
  //   "Please enter a valid number"
  // )
  company_login_name: Yup.string()
    .required("Login name is required")
    .min(3, "Minimum 3 chars required")
    .max(200, "Cannot exceed 200 chars")
    .matches(/^[a-zA-Z0-9-]+$/, "Only alphanumeric with hyphen is allowed"),
  company_address: Yup.string()
    .required("Address is required")
    .min(3, "Minimum 3 chars required")
    .max(200, "Cannot exceed 200 chars"),
  company_country: Yup.string().required("Country is required"),
  company_currency: Yup.string().required("Currency is required"),
  company_timezone: Yup.string().required("Timezone is required"),
  company_email: Yup.string()
    .required("Company email is required")
    .email("Please enter a valid email"),
  company_industry: Yup.string().nullable(),
  company_logo: Yup.mixed().required("Profile Picture is Required"),
  company_status: Yup.string()
    .required("Company Status is required")
    .oneOf(CompanyStatus, "Invalid Company Status"),
});

function AccountDetails({ companyDetails }) {
  const dispatch = useDispatch();

  const customerDetailsForm = useFormikWrapper({
    initialValues: {
      company_id: "",
      company_uid: "",
      company_name: "",
      company_login_name: "",
      company_industry: "",
      company_email: "",
      company_phone: "",
      company_currency: "",
      company_timezone: "",
      company_country: "",
      company_address: "",
      created_at: "",
      created_by: "",
      company_logo: "",
      account_manager: "",
      company_status: "",
      trial_period: null,
    },
    validationSchema: validationSchema,
    onSubmit: () => {
      setOpenModal("pop-up");
    },
  });

  const initForm = () => {
    customerDetailsForm.resetForm({
      values: {
        company_id: companyDetails?.company_id || "",
        company_uid: companyDetails?.company_uid || "",
        company_name: companyDetails?.company_name || "",
        company_login_name: companyDetails?.company_login_name || "",
        company_industry: companyDetails?.company_industry || "",
        company_email: companyDetails?.company_email || "",
        company_phone: companyDetails?.company_phone || "",
        company_currency: companyDetails?.company_currency || "",
        company_timezone: companyDetails?.company_timezone || "",
        company_country: companyDetails?.company_country || "",
        company_address: companyDetails?.company_address || "",
        created_at:
          moment(companyDetails?.created_at).format("YYYY-MM-DD") || "",
        created_by: companyDetails?.created_by?.fullName || "",
        company_logo: companyDetails?.company_logo || "",
        account_manager: companyDetails?.account_manager || "",
        company_status: companyDetails?.company_status || "",
        trial_period: companyDetails?.trial_period || null,
      },
    });
  };

  const [openModal, setOpenModal] = useState();
  const [editMode, setEditMode] = useState(false);
  const navigate = useNavigate();

  const industryList = useSelector((state) => state.company.industry);

  useEffect(() => {
    if (!industryList) dispatch(actions.GETINDUSTRY_REQ({ no_loader: true }));
  }, []);

  useEffect(() => {
    // companyDetails?.company_uid &&
    //   dispatch(
    //     actions.GETCOMPANYPOLICY_REQ({
    //       company_uid: companyDetails?.company_uid,
    //       no_loader: true,
    //     })
    //   );
    setEditMode(false);
    initForm();
  }, [companyDetails]);

  useEffect(() => {
    if(customerDetailsForm?.values?.company_status === "SALE"){
      // Set trial_period to 14 days from today if not already set (only in edit mode, not readonly)
      if(!customerDetailsForm?.values?.trial_period && editMode){
        customerDetailsForm.setFieldValue('trial_period', moment().add(14, 'days').format('YYYY-MM-DD'))
      }
    } else {
      // Clear trial_period if company_status is not SALE (only in edit mode, not readonly)
      if(editMode){
        customerDetailsForm.setFieldValue('trial_period', null)
      }
    }
  },[customerDetailsForm?.values?.company_status, editMode]);

  const isBannerActive = useSelector(
    (state) => state.company.policy?.popup_banner?.is_enabled
  );

  const handleEdit = () => {
    setOpenModal(undefined);
    if (customerDetailsForm.isValid) {
      dispatch(actions.EDITCOMPANY_REQ(customerDetailsForm.values));
    }
  };

  const toggleCompany = (company) => {
    dispatch(
      actions.TOGGLECOMPANY_REQ({
        company_uid: company.company_uid,
        status: company.is_active ? "deactivate" : "activate",
        reason: company.reason,
      })
    );
  };

  const columns = [
    {
      name: "Employee Code",
      key: "coworker_code",
    },
    {
      name: "Name",
      key: "first_name",
      formatText: (cell, row) => {
        return `${cell || ""} ${row.last_name || ""}`;
      },
    },
    { name: "Email", key: "email" },
    { name: "Primary Phone", key: "primary_phone_number" },
    { name: "Designation", key: "designation" },
    { name: "Role", key: "role" },
    {
      name: "Status",
      key: "is_active",
      formatText: (isActive) => {
        return isActive ? "Active" : "Inactive";
      },
      processClassName: (isActive) =>
        isActive ? "text-green-500" : "text-red-500",
    },
  ];

  return (
    <>
      <div class="h-full mt-3">
        <div class="relative h-full w-full bg-white rounded-lg shadow px-4">
          <div class="p-2">
            <div class="flow-root">
              <div class="-mx-4 -my-2 sm:-mx-6 lg:-mx-8">
                <div class="inline-block min-w-full py-4 align-middle sm:px-6 lg:px-8">
                  <div class="mx-auto pb-3 border-b sm:flex sm:items-center sm:justify-between">
                    <h3 class="text-lg font-semibold leading-6 text-gray-900">
                      Account Details
                    </h3>
                    <div class="mt-3 sm:ml-4 sm:mt-0">
                      <ACL showFor={[SUPERADMIN, ADMIN, FINANCEADMIN]}>
                        {" "}
                        {!editMode && (
                          <div class="flex items-center justify-center space-x-3">
                            {isBannerActive && (
                              <Chip
                                label={"Banner Active"}
                                className="font-medium [&_.chip-bg]:bg-indigo-500"
                                onClick={() => {
                                  navigate(
                                    `/customers/${companyDetails?.company_uid}/policy#banner`
                                  );
                                }}
                              />
                            )}
                            <Chip
                              label={
                                companyDetails.is_active ? "Active" : "Inactive"
                              }
                              className={
                                companyDetails.is_active
                                  ? "font-medium [&_.label]:text-green-600"
                                  : "font-medium [&_.label]:text-red-600"
                              }
                              bgColor={
                                companyDetails.is_active
                                  ? "rgb(205 247 222)"
                                  : "#FBD5D5"
                              }
                            />
                            <IconButton onClick={() => setEditMode(true)}>
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 24 24"
                                fill="currentColor"
                                class="w-4 h-4"
                              >
                                <path d="M21.731 2.269a2.625 2.625 0 00-3.712 0l-1.157 1.157 3.712 3.712 1.157-1.157a2.625 2.625 0 000-3.712zM19.513 8.199l-3.712-3.712-12.15 12.15a5.25 5.25 0 00-1.32 2.214l-.8 2.685a.75.75 0 00.933.933l2.685-.8a5.25 5.25 0 002.214-1.32L19.513 8.2z" />
                              </svg>
                            </IconButton>

                            <ToggleCustomerStatus
                              data={companyDetails}
                              onConfirm={toggleCompany}
                            />
                            {/* <button
                            type="button"
                            class="rounded-xl bg-indigo-100 p-2 text-indigo-600 hover:bg-indigo-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              fill="currentColor"
                              class="w-4 h-4"
                            >
                              <path
                                fill-rule="evenodd"
                                d="M6.72 5.66l11.62 11.62A8.25 8.25 0 006.72 5.66zm10.56 12.68L5.66 6.72a8.25 8.25 0 0011.62 11.62zM5.105 5.106c3.807-3.808 9.98-3.808 13.788 0 3.808 3.807 3.808 9.98 0 13.788-3.807 3.808-9.98 3.808-13.788 0-3.808-3.807-3.808-9.98 0-13.788z"
                                clip-rule="evenodd"
                              />
                            </svg>
                          </button> */}
                          </div>
                        )}
                        {editMode && (
                          <div class="flex items-center justify-center space-x-3">
                            <FlatButton
                              className="w-[100px] inline-flex justify-center items-center gap-x-1.5"
                              appearance="secondary"
                              onClick={() => {
                                initForm();
                                setEditMode(false);
                              }}
                            >
                              Cancel
                            </FlatButton>
                            <FlatButton
                              className="w-[100px] inline-flex justify-center items-center gap-x-1.5"
                              onClick={() => {
                                customerDetailsForm.submitForm();
                              }}
                            >
                              Save
                            </FlatButton>
                          </div>
                        )}
                      </ACL>
                    </div>
                  </div>
                  <div class="mt-0">
                    <div className="grid mt-4 mb-4 grid-cols-1 gap-x-6 gap-y-6 sm:grid-cols-2">
                      <TextBox
                        formik={customerDetailsForm}
                        readOnly={!editMode}
                        disabled={editMode}
                        name="company_id"
                        label="Company ID"
                        required
                        placeholder="Company ID"
                        copyAction
                      />
                      <TextBox
                        formik={customerDetailsForm}
                        readOnly={!editMode}
                        disabled={editMode}
                        name="company_uid"
                        label="Company UID"
                        required
                        placeholder="Company UID"
                        copyAction
                      />
                      <TextBox
                        formik={customerDetailsForm}
                        readOnly={!editMode}
                        name="company_name"
                        label="Company Name"
                        required
                        placeholder="Company Name"
                      />

                      <TextBox
                        formik={customerDetailsForm}
                        readOnly={!editMode}
                        name="company_login_name"
                        label="Company Login Name"
                        required
                        placeholder="Company Login Name"
                        copyAction
                      />

                      <SearchDropdown
                        formik={customerDetailsForm}
                        readOnly={!editMode}
                        name="company_industry"
                        label="Industry type"
                        showNull={true}
                        options={industryList}
                        optionId="value"
                        optionName="label"
                      />
                      <SearchDropdown
                        formik={customerDetailsForm}
                        readOnly={!editMode}
                        name="company_status"
                        label="Stage"
                        showNull={false}
                        options={CompanyStatus}
                      />
                      <TextBox
                        formik={customerDetailsForm}
                        readOnly={!editMode}
                        name="company_email"
                        label="Company Email"
                        placeholder="Company Email"
                        required
                      />
                      <TextBox
                        formik={customerDetailsForm}
                        readOnly={!editMode}
                        name="company_phone"
                        label="Company Phone"
                        placeholder="Company Phone"
                      />
                      <TextBox
                        formik={customerDetailsForm}
                        readOnly={!editMode}
                        name="company_address"
                        label="Company Address"
                        required
                        placeholder="Company Address"
                      />
                      <SearchDropdown
                        formik={customerDetailsForm}
                        readOnly={!editMode}
                        name="company_country"
                        options={countries}
                        optionId="value"
                        optionName="label"
                        required
                        label="Country"
                        placeholder="Company Country"
                      />

                      <SearchDropdown
                        formik={customerDetailsForm}
                        readOnly={!editMode}
                        name="company_currency"
                        label="Company Currency"
                        placeholder="Company Currency"
                        options={currencies}
                        optionId="id"
                        required
                        optionName="currencyName"
                        formatDisplayName={(currency) =>
                          `${currency.currencyName} ${currency.currencySymbol
                            ? "(" + currency.currencySymbol + ")"
                            : ""
                          }`
                        }
                      />
                      <SearchDropdown
                        formik={customerDetailsForm}
                        readOnly={!editMode}
                        name="company_timezone"
                        label="Company Timezone"
                        placeholder="Company Timezone"
                        options={timezones}
                        required
                        optionName="display_name"
                      />
                      <AddAccountManager
                        formik={customerDetailsForm}
                        readOnly={!editMode}
                        name="account_manager"
                        label="Account Manager"
                        placeholder="Account Manager"
                      />
                      {customerDetailsForm?.values?.company_status === "SALE" && (
                        !editMode ? (
                          <div className="mt-1">
                            <label className="mb-2 block text-sm font-medium text-gray-700 mb-2">
                              Trial Period
                            </label>
                            <div className="text-gray-900">
                              {customerDetailsForm.values.trial_period ? moment(customerDetailsForm.values.trial_period).format('YYYY-MM-DD') : '---'}
                            </div>
                          </div>
                        ) : (
                          <div className="mt-1">
                            <label className="mb-2 block text-sm font-medium text-gray-700 mb-1">
                              Trial Period
                            </label>
                            <Datepicker
                                inputClassName={(c) => {
                                  return `${c} !font-normal`
                                }}
                              classNames={{
                                footer: (p) => `
                                    px-2
                                    pb-2
                                    [&_button:first-of-type]:!bg-white
                                    [&_button:first-of-type]:!rounded-md
                                    [&_button:first-of-type]:!shadow-sm
                                    [&_button:first-of-type]:!disabled:bg-gray-200
                                    [&_button:first-of-type]:!disabled:opacity-50
                                    [&_button:first-of-type]:!text-gray-900
                                    [&_button:first-of-type]:!font-semibold
                                    [&_button:first-of-type]:!ring-gray-300
                                    [&_button:first-of-type:hover]:!bg-gray-50
                                    [&_button:first-of-type]:!ring-1
                                    [&_button:first-of-type]:!ring-inset
                                    [&_button]:w-[100px]
                                    [&_button]:ml-auto
                                    [&_button]:cursor-pointer
                                    [&_button]:bg-gray-800
                                    [&_button]:rounded-md
                                    [&_button]:shadow-sm
                                    [&_button]:disabled:bg-gray-500
                                    [&_button]:disabled:opacity-75
                                    [&_button]:text-white
                                    [&_button]:font-semibold
                                    [&_button:hover]:bg-gray-600
                                    [&_button:focus-visible]:outline-gray-600
                                    [&_button:focus-visible]:outline
                                    [&_button:focus-visible]:outline-2
                                    [&_button:focus-visible]:outline-offset-2`,
                              }}
                              containerClassName={(p) => `
                                    relative w-full text-gray-700
                                    [&_.bg-indigo-100]:!bg-gray-100
                                    [&_.bg-indigo-500]:!bg-gray-800
                                    [&_.line-through]:text-gray-200
                            `}
                              placeholder="Select trial period date"
                              primaryColor="indigo"
                              value={customerDetailsForm.values.trial_period ? {
                                startDate: customerDetailsForm.values.trial_period,
                                endDate: customerDetailsForm.values.trial_period
                              } : {
                                startDate: moment().add(14, 'days').format('YYYY-MM-DD'),
                                endDate: moment().add(14, 'days').format('YYYY-MM-DD')
                              }}
                              onChange={(value) => customerDetailsForm.setFieldValue('trial_period', value?.startDate || null)}
                              showFooter
                              asSingle
                              minDate={new Date()}
                              displayFormat="DD-MM-YYYY"
                              popoverDirection="down"
                            />
                          </div>
                        )
                      )}
                      {editMode && (
                        <FileChooser
                          formik={customerDetailsForm}
                          readOnly={!editMode}
                          name="company_logo"
                          showPreview
                          required
                          label="Company Logo"
                          placeholder="Company Logo"
                          accept=".png,.jpg,.jpeg"
                        />
                      )}
                      <TextBox
                        formik={customerDetailsForm}
                        readOnly={!editMode}
                        disabled={editMode}
                        name="created_at"
                        label="Account Created On"
                        placeholder="Account Created On"
                      />
                      <TextBox
                        formik={customerDetailsForm}
                        readOnly={!editMode}
                        disabled={editMode}
                        name="created_by"
                        label="Account Created By"
                        placeholder="Account Created By"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Popup
          modalState={[openModal, setOpenModal]}
          onConfirm={handleEdit}
          content={
            <>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="mx-auto mb-4 h-14 w-14 text-gray-400 dark:text-gray-200"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
                />
              </svg>
              <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                Are you sure you want to edit the properties of{" "}
                <b>{companyDetails?.company_name}</b>?
              </h3>
            </>
          }
        />
      </div>
      <br />
      {/* Assigend Coworkers */}
      <div class="h-full">
        <div class="relative h-full w-full overflow-hidden bg-white rounded-lg shadow px-4">
          <div class="p-2">
            <div class="flow-root">
              <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div class="inline-block min-w-full py-4 align-middle sm:px-6 lg:px-8">
                  <DataTable
                    name="Assigned Coworkers"
                    columns={columns}
                    remote={false}
                    data={companyDetails?.users}
                    totalCount={companyDetails?.users?.length}
                    toolbar={{
                      search: {
                        enable: true,
                        searchBy: "name",
                        placeholder: "Search Coworkers...",
                      },
                    }}
                    footer={{ paginator: { enable: true, limits: [10] } }}
                  // paginator={{ enable: true, limits: [10] }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AccountDetails;
